import type { ProLayoutProps } from '@ant-design/pro-components';
import {
  DEFAULT_SIDER_WIDTH,
  HEADER_HEIGHT,
} from '../src/components/Layout/layoutConstants';
import { BizAppConfig } from './application.manifest';
import { getBrandAppName } from './brand';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'realDark',
  colorPrimary: '#1890ff',
  layout: 'mix',
  contentWidth: 'Fluid',
  siderWidth: DEFAULT_SIDER_WIDTH,
  menu: { defaultOpenAll: true, ignoreFlatMenu: true, autoClose: false },
  fixedHeader: true,
  fixSiderbar: true,
  pwa: true,
  title: getBrandAppName(),
  logo: BizAppConfig.appLogo,
  token: {
    header: { heightLayoutHeader: HEADER_HEIGHT },
  },
  splitMenus: true,
};
export default Settings;
